function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    strokeWidth: 1.5,
    style: {
      stroke: "var(--mui-palette-icon-schieferBlau, #4A5966)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6.80269C14.1175 6.29218 13.0929 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C13.0929 18 14.1175 17.7078 15 17.1973",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    style: {
      stroke: "var(--mui-palette-icon-schieferBlau, #4A5966)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5H10",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    style: {
      stroke: "var(--mui-palette-icon-schieferBlau, #4A5966)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13.5H10",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    style: {
      stroke: "var(--mui-palette-icon-schieferBlau, #4A5966)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/Euro.fc915e24b96abacdadc547ea80496a37.svg";
export { ForwardRef as ReactComponent };